import Events from '../utils/events';
import { EV_BODY_SCROLL, EV_PAGE_VIEW } from './events';

const steps = [10, 25, 50, 75, 90];
let passedSteps: number[] = [];

const checkBodyScroll = () => {
  const target = document.querySelector('html');
  if (target) {
    const scrolled = ((target.scrollTop + target.clientHeight) / target.scrollHeight) * 100;
    steps.forEach((step) => {
      if (scrolled >= step && passedSteps.indexOf(step) < 0) {
        passedSteps.push(step);
        Events.emit(EV_BODY_SCROLL, step);
      }
    });
  }
};

export default () => {
  Events.on(EV_PAGE_VIEW, () => {
    passedSteps = [];
    checkBodyScroll();
  });

  window.addEventListener('scroll', checkBodyScroll);

  checkBodyScroll();
};
